import { createSlice } from '@reduxjs/toolkit';
import {
  serviceGetDataModel,
  servicePostDataModel,
  servicePutDataModel,
  serviceDeleteDataModel
} from 'utils';

const initialState = {
  data: null,
  isLoaded: {
    post: false,
    put: false,
    delete: false,
    get: false,
  },
  success: {
    post: false,
    put: false,
    delete: false,
    get: false,
  },
  error: {
    post: false,
    put: false,
    delete: false,
    get: false,
  },
};

const dataModelSlice = createSlice({
  name: 'dataModel',
  initialState,
  reducers: {

    dataRequest(state, action) {
      return { ...state, isLoaded: { ...state.isLoaded, [action.payload]: true } };
    },

    dataSuccess(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        success: { ...state.success, [action.payload.fetchType]: true },
        data: action.payload.data || null,
      };
    },

    dataFailure(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        error: { ...state.error, [action.payload.fetchType]: action.payload.data?.message },
      };
    },

    cleanUpDataModel(state) {
      return initialState;
    },

    cleanUpMessageDataModel(state) {
      return {
        ...state,
        dataType: null,
        isLoaded: initialState.isLoaded,
        success: initialState.success,
        error: initialState.error,
      };
    },
  },
});

const {
  dataRequest,
  dataSuccess,
  dataFailure,
  cleanUpDataModel,
  cleanUpMessageDataModel
} = dataModelSlice.actions;

const fetchGetDataModel = (query) => {
  return (dispatch) => {
    dispatch(dataRequest('get'));
    serviceGetDataModel(query)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'get'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'get'})));
  };
};

const fetchPostDataModel = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('post'));
    servicePostDataModel(body)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'post'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'post'})));
  };
};

const fetchPutDataModel = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('put'));
    servicePutDataModel(body)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'put'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'put'})));
  };
};

const fetchDeleteDataModel = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('delete'));
    serviceDeleteDataModel(body)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'delete'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'delete'})));
  };
};

export {
  fetchGetDataModel,
  fetchPostDataModel,
  fetchPutDataModel,
  fetchDeleteDataModel,
  cleanUpDataModel,
  cleanUpMessageDataModel
};

export default dataModelSlice.reducer;
